/**
 * @description: 仓库管理-供应商管理
 * @author: ccy
 * @update: 大腿 (2017-3-29)
 * @update: hwx
 */
<template>
	<div class="supplier-manage">
		<div class="supplier-list" v-show="showList">
			<div class="row row-margin">
				<button type="button" class="btn btn-flat btn-middle btn-orange" id="add-supplier" @click="openPop">添加供应商</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange" @click="toPrice">合同价管理</button>
			</div>
			<div class="row">
				<div class="col-md-1 ct-col supplier-tit-sel">
					<select class="form-control" ref="query_sel">
						<option value="name">供应商名称</option>
						<option value="contact">联系人</option>
						<option value="contact_mobile">联系方式</option>
					</select>
				</div>
				<div class="col-md-2 supplier-con-val">
					<input type="text" class="form-control" v-model="query_val" :placeholder="query_phd">
				</div>
				<button type="button" class="btn btn-flat btn-small btn-orange pull-right" @click="supplierQuery">查询</button>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="supplierlist" style="margin-top:10px"></table>
			</div>
		</div>
		<!-- 合同价管理 -->
		<div class="supplier-price" v-show="showPrice">
			<div class="row row-margin">
				<label class="ct-label" v-show="!getContractPriceByGoods">门店:</label>
				<div class="col-md-2 ct-col" v-show="!getContractPriceByGoods">
					<select class="form-control" ref="price_shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="ct-label">供应商:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="price_agent" data-placeholder="请选择供应商">
						<option value=""></option>
					</select>
				</div>
				<label class="ct-label">商品:</label>
				<div class="col-md-2 ct-col">
					<input type="text" class="form-control" v-model="price_name" placeholder="请输入商品名称">
				</div>
				<el-checkbox v-model="only_show_diff_price" v-show="getContractPriceByGoods">仅显示合同价差异商品</el-checkbox>
			</div>
			<div class="row">
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-orange" @click="multiDelPrice">合同价批量删除</button>
					<button type="button" class="btn btn-flat btn-small" :class="[getContractPriceByGoods?'btn-border-gray':'btn-orange']" @click="changeGetMethod(false)">按门店</button>
					<button type="button" class="btn btn-flat btn-small" :class="[getContractPriceByGoods?'btn-orange':'btn-border-gray']" @click="changeGetMethod(true)">按商品</button>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryPrice">查询</button>
					<a href="https://vodonline.oss-cn-beijing.aliyuncs.com/Download/contractPriceTemplate.xls" class="btn btn-flat btn-middle btn-orange">合同价模板下载</a>
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="priceXlsFun">合同价导入</button>
					<input type="file" @change="uploadPriceXls($event)" id="priceXlsFile" ref="priceXlsFile" class="ele-hide">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="addPrice">新增合同价</button>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="getExportSet" v-show="!getContractPriceByGoods">导出</button>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="byGoodExport" v-show="getContractPriceByGoods">导出</button>
					<button type="button" class="btn btn-flat btn-small btn-gray" @click="backList">返回</button>
				</div>
			</div>
			<div class="table-responsive" v-show="!getContractPriceByGoods">
				<table class="table table-bordered table-hover" data-pagination="true" ref="price_list" style="margin-top:10px"></table>
			</div>
			<el-table
				class="by-good-table"
				v-show="getContractPriceByGoods"
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table"
                default-expand-all>
                <el-table-column type="expand">
				    <template slot-scope="scope">
						<div class="gray-table">
							<div class="table-header">
								<div class="name">门店名称</div>
								<div class="price">合同价</div>
							</div>
					        <div class="table-row" v-for="item in scope.row.price_info">
					        	<div class="name">{{item.shop_name}}</div>
					        	<div class="price">{{item.price}}</div>
					        </div>
						</div>
				    </template>
			    </el-table-column>
                <el-table-column prop="supplier_name" label="供应商名称"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称"></el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                v-show="getContractPriceByGoods"
                :page-size="page_size"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getContractPriceGroupGoods">
            </el-pagination>
		</div>
		<!-- 导出设置弹窗 -->
		<div class="ele-hide" ref="export_alert">
			<div class="set-export sel-seldiv">
				<h3>请选择导出报表需要的显示的字段</h3>
				<ul class="set-area clearfix">
					<li>
						<input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
						<label>全选</label>
					</li>
					<li>
						<input type="checkbox" v-model='export_checkModel' value="supplier_name">
						<label>供应商名称</label>
					</li>
					<li>
						<input type="checkbox" v-model='export_checkModel' value="shop_name">
						<label>门店名称</label>
					</li>
					<li>
						<input type="checkbox" v-model='export_checkModel' value="merchant_goods_name">
						<label>商品名称</label>
					</li>
					<li>
						<input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
						<label>商品单位</label>
					</li>
					<li>
						<input type="checkbox" v-model='export_checkModel' value="price">
						<label>合同价</label>
					</li>
				</ul>
				<h3>请选择导出报表的文件格式</h3>
				<ul class="clearfix">
					<li>
						<input type="radio" v-model='export_type' value="1">
						<label>excel表格</label>
					</li>
					<li>
						<input type="radio" v-model='export_type' value="2">
						<label>pdf文件</label>
					</li>
				</ul>
			</div>
		</div>
		<!-- 供应商编辑 -->
		<div class="add-supplier" ref="addsupplier">
			<div class="row">
				<div class="col-md-3 title">供应商名称：</div>
				<div class="col-md-8">
					<input type="text" class="form-control" id="supplier-name" v-model="name" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-3 title">联系人：</div>
				<div class="col-md-8">
					<input type="text" class="form-control" id="linkman" v-model="contact" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-3 title">联系方式：</div>
				<div class="col-md-8">
					<input type="text" class="form-control" id="contact" v-model="mobile" />
				</div>
			</div>
			<div class="row btns">
				<div class="col-md-4">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="doOpe">确定</button>
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-small btn-gray" @click="closeLayer">取消</button>
				</div>
			</div>
		</div>
		<!-- 合同价编辑 -->
		<div class="pb-edit-alert" ref="price_edit">
			<div class="row">
				<label class="col-md-3">供应商名称：</label>
				<div class="col-md-9 ct-col">
					<select class="form-control" data-placeholder="请选择供应商名称" ref="price_supplier"></select>
				</div>
			</div>
			<div class="row">
				<label class="col-md-3">商品名称：</label>
				<div class="col-md-9">
					<input class="form-control input-readonly" placeholder="请选择商品名称" v-model="price_goods_name" ref="price_goods_name" @click="openPriceGoods" readonly>
				</div>
			</div>
			<div class="row">
				<label class="col-md-3">商品单位：</label>
				<div class="col-md-9">
					<input class="form-control" placeholder="系统自动显示" v-model.trim="price_goods_unit" readonly>
				</div>
			</div>
			<div class="row">
				<label class="col-md-3">合同价：</label>
				<div class="col-md-9">
					<input class="form-control" placeholder="请输入合同价" v-model.trim="price_amount">
				</div>
			</div>
			<div class="price-sync" v-show="modify_price == '1'">
				<h3>资料同步：（以下门店如需同步更新该供应商下相同商品的合同价请勾选）</h3>
				<p>注：商品合同价需要满足【商品名称】，【商品类型】，【商品单位】一致时才能同步。</p>
				<el-checkbox :indeterminate="sync_sign" v-model="sync_check_all" @change="syncCheckAll">全选</el-checkbox>
				<el-checkbox-group v-model="sync_shop_ids" @change="syncShop">
					<el-checkbox v-for="item in shop_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<!-- 商品列表 -->
		<div class="price-goods" ref="price_goods">
			<div class="row">
				<div class="col-md-4 ct-col">
					<select class="form-control" data-placeholder="请选择商品类型" ref="goods_type">
						<option value=""></option>
					</select>
				</div>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入商品名称" v-model="goods_name" @keyup.13="queryGoods" />
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryGoods">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="goods_list"></table>
			</div>
			<div class="row btns">
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="saveGoods">保存</button>
				<button type="button" class="btn btn-flat btn-small btn-gray" @click="closeGoods">取消</button>
			</div>
		</div>
		<!-- 合同价批量删除弹窗 -->
		<div class="multi-del-pop ele-hide" ref="multi_del_pop">
			<div class="tip">注：确定删除后，选中的供应商下的所有合同价信息将删除，且不可恢复！</div>
			<el-form v-model="multi_pop_form" label-width="80px">
				<el-form-item label="门店">
					<el-select v-model="multi_pop_form.shop_id" disabled placeholder="请选择">
					    <el-option
						    v-for="item in shop_list"
						    :key="item.id"
						    :label="item.name"
						    :value="item.id">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="供应商">
					<el-select v-model="multi_pop_form.supplier_id" placeholder="请选择供应商" popper-class="high-index">
					    <el-option
						    v-for="item in suppliers"
						    :key="item.id"
						    :label="item.name"
						    :value="item.id">
					    </el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import * as types from '@/store/types';
	import Vue from 'vue';
	export default {
		name: 'supplier_manage',
		data() {
			return {
				supplier_sr_cgh_report: {},

				showList: true,
				showPrice: false,
				shop_list: [],
				query_val: "",
				query_phd: "请输入供应商名称",
				query_field: "name",
				name: "",
				contact: "",
				mobile: "",
				modify_id: "", // 修改供应商时使用
				rowIndx: "", // 修改供应商成功后表格更新使用
				supplier_list: [{
					"index": "1",
					"supplier_name": "aaa",
					"linkman": "张三",
					"contact": "18800001111",
				}, {
					"index": "1",
					"supplier_name": "xxx",
					"linkman": "张三",
					"contact": "18800001111",
				}],
				price_name: '',
				modify_price: '1',
				price_goods_id: '',
				price_goods_name: '',
				price_goods_unit: '',
				price_amount: '',
				goods_name: '',
				sync_sign: false,
				sync_check_all: false,
				sync_shop_ids: [],
				getContractPriceByGoods: false, // 按商品获取合同价
				only_show_diff_price: false, // 是否仅显示合同价差异商品 -1否 1是
				loading: false,
				list_table: [],
				list_page: 1,
				page_size: 5,
				list_total: 0, 

				export_allcheck: false,
				c_export_allcheck: false,
				export_checkModel: [],
				export_checkData: ['supplier_name', 'shop_name', 'merchant_goods_name', 'goods_unit_name', 'price'],
				export_type: 1,
				suppliers: [],
				multi_pop_form: {
					shop_id: '',
					supplier_id: ''
				}
			}
		},
		computed: {
			menunew() {
				return JSON.parse(this.$store.state.menunew)
			}
		},
		watch: {
			export_checkModel: {
				handler: function(val, oldVal) {
					if(this.export_checkModel.length >= this.export_checkData.length) {
						this.export_allcheck = true;
						this.c_export_allcheck = true;
					} else {
						this.export_allcheck = false;
						this.c_export_allcheck = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			let _this = this;
			// 跳转菜单
			_this.getPageMenu();
			this.$nextTick(function() {
				// 下拉选项
				$(_this.$refs.query_sel).select2({
					language: "zh-CN",
					minimumResultsForSearch: -1,
					width: '100px'
				}).change(function() {
					_this.query_field = $(this).val();
					_this.query_val = '';
					if(_this.query_field == 'name') {
						_this.query_phd = '请输入供应商名称';
					} else if(_this.query_field == 'contact') {
						_this.query_phd = '请输入联系人';
					} else if(_this.query_field == 'contact_mobile') {
						_this.query_phd = '请输入联系方式';
					}
				});
				this.innitTable();
				this.getShopData();
				this.getGoodsType();
				this.getSupplierSel();
			});
		},
		methods: {
			// 跳转菜单
			getPageMenu: function() {
				this.menunew.forEach(i => {
					if(i.id == '544') {
						i.submenu.forEach(j => {
							if(j.id == '566') {
								j.submenu.forEach(k => {
                                    if(k.id == '743') {
                                        // 采购汇总报表
                                        this.supplier_sr_cgh_report = k
                                    }
                                })
							}
						})
					}
				})
			},
			// 跳转参数
			setPageParams(supplier_id) {
				const obj = {
					name: 'sr_cgh_report',
					params: {
						supplier_id: supplier_id
					}
				}
				this.$emit("pageLink", this.supplier_sr_cgh_report, obj)
			},
			// 获取供应商
			getSupplierSel: function() {
				let _this = this;
				
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": "0",
							"page_size": "0"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getSupplier",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [{ id: "0", text: "全部" }];
							$.each(data.response.result.data.rows, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});

							$(_this.$refs.price_agent).select2({
								data: arr,
								allowClear: true,
								language: "zh-CN",
								width: '100%'
							});
							arr.shift();
							$(_this.$refs.price_supplier).select2({
								data: arr,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								_this.price_goods_id = '';
								_this.price_goods_name = '';
							});
							_this.suppliers = data.response.result.data.rows
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.shop_list = data.response.result;
							_this.shop_list.shift();
							$.each(data.response.result, function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.price_shop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});

							$(_this.$refs.sgoods_shop).select2({
								data: shopDatas,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			innitTable: function() {
				let _this = this;
				$(_this.$refs.supplierlist).bootstrapTable('destroy');
				$(_this.$refs.supplierlist).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getSupplierList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "index",
						title: "序号",
						width: "10%",
						formatter: function(value, row, index) {
							return index + 1;
						}
					}, {
						field: "id",
						title: "供应商id",
						visible: false
					}, {
						field: "name",
						title: "供应商名称",
						width: "20%"
					}, {
						field: "contact",
						title: "联系人",
						width: "15%"
					}, {
						field: "contact_mobile",
						title: "联系方式",
						width: "15%"
					}, {
						title: "操作",
						width: "20%",
						events: {
							'click .modify': function(e, value, row, index) {
								_this.name = row.name;
								_this.contact = row.contact;
								_this.mobile = row.contact_mobile;
								_this.modify_id = row.id;
								_this.rowIndx = index;
								$("#supplier-name").attr("disabled", "true");
								layer.open({
									type: 1,
									title: '修改供应商',
									skin: 'layui-layer-rim', //加上边框
									area: ['500px', '380px'], //宽高
									content: $(_this.$refs.addsupplier)
								});
							},
							'click .delete': function(e, value, row, index) {
								//debugger;
								layer.confirm('确认删除' + row.name + '吗？删除后该供应商下的合同价信息也将全部删除', {
									btn: ['确定', '取消'] //按钮
								}, function() {
									_this.deleteSupplier(row.id);
								});
							},
							'click .goods': function(e, value, row, index) {
								// _this.modify_id = row.id;
								// _this.sgoods_tit = row.name;
								// $(_this.$refs.sgoods_shop).val('').trigger('change');
								// $(_this.$refs.sgoods_type).val('').trigger('change');
								// _this.sgoods_name = '';
								// _this.initSupplierGoods();
								// _this.showList = false;
								if(_this.supplier_sr_cgh_report.id) {
									_this.setPageParams(row.id);
								} else {
									layer.msg('没有查看权限');
								}
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue modify">修改</span><span class="text-blue delete">删除</span><span class="text-blue goods">商品</span>'
						}
					}],
					data: _this.supplier_list
				});
			},
			// 获取供应商列表
			getSupplierList: function(params) {
				let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
				let name = '',
					contact = '',
					contact_mobile = '';
				if(_this.query_field == 'name') {
					name = _this.query_val;
				} else if(_this.query_field == 'contact') {
					contact = _this.query_val;
				} else if(_this.query_field == 'contact_mobile') {
					contact_mobile = _this.query_val;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"name": name,
							"contact": contact,
							"contact_mobile": contact_mobile
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/searchMerchantSupplierList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
							
							// 下拉框
							let arr = [];
							$.each(data.response.result.data.rows, function(k, v) {
								arr.push({
									id: v.id,
									text: v.name,
								});
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			supplierQuery: function() {
				this.innitTable();
			},
			openPop: function() {
				let _this = this;
				_this.modify_id = '';
				_this.name = "";
				_this.contact = "";
				_this.mobile = "";
				$("#supplier-name").removeAttr("disabled");
				layer.open({
					type: 1,
					title: '添加供应商',
					skin: 'layui-layer-rim', //加上边框
					area: ['500px', '450px'], //宽高
					content: $(_this.$refs.addsupplier)
				});
			},
			closeLayer: function() {
				layer.closeAll();
			},
			// 添加/修改供应商操作
			doOpe: function() {
				let _this = this;

				if(_this.name == "") {
					layer.msg("请填写供应商名称");
					return;
				} else if(_this.contact == "") {
					layer.msg("请填写联系人");
					return;
				} else if(_this.mobile == "") {
					layer.msg("请填写联系方式");
					return;
				}
				if(_this.modify_id == "") { //新增
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"name": _this.name,
								"contact": _this.contact, //联系人
								"contact_mobile": _this.mobile //联系方式
							}
						},
						"comment": ""
					};
					let datas2 = JSON.stringify(datas);
					layer.load(0, {
						shade: [0.1, '#ececec'] //0.1透明度的白色背景
					});
					$.ajax({
						type: "post",
						dataType: "json",
						url: Vue.ctUrl + "stock/addMerchantSupplier",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: {
							json: datas2
						},
						success: function(data) {
							layer.closeAll();
							if(data.response.result_code == "true") {
								layer.msg("新增成功！");
								_this.innitTable();
							} else {
								Vue.timeoutfun(data.response.result_status,_this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.closeAll();
							layer.msg("出错啦");
						}
					});
				} else { //修改
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": _this.modify_id,
								"name": _this.name,
								"contact": _this.contact, //联系人
								"contact_mobile": _this.mobile //联系方式
							}
						},
						"comment": ""
					};
					let datas2 = JSON.stringify(datas);
					layer.load(0, {
						shade: [0.1, '#ececec'] //0.1透明度的白色背景
					});
					$.ajax({
						type: "post",
						dataType: "json",
						url: Vue.ctUrl + "stock/updateMerchantSupplier",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: {
							json: datas2
						},
						success: function(data) {
							layer.closeAll();
							if(data.response.result_code == "true") {
								// 更新行
								layer.msg("修改成功！");
								$(_this.$refs.supplierlist).bootstrapTable("updateRow", { index: _this.rowIndx, row: data.response.param });
							} else {
								Vue.timeoutfun(data.response.result_status,_this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.closeAll();
							layer.msg("出错啦");
						}
					});
				}
			},
			// 删除供应商
			deleteSupplier: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
							"name": "",
							"contact": "", //联系人
							"contact_mobile": "", //联系方式
							"status": "-1"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				layer.load(0, {
					shade: [0.1, '#ececec'] // 0.1透明度的白色背景
				});
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/updateMerchantSupplier",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							layer.msg("删除成功！");
							//							$(_this.$refs.supplierlist).bootstrapTable("removeByUniqueId", id);
							$(_this.$refs.supplierlist).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 跳转到合同价列表
			toPrice: function() {
				this.showList = false;
				this.showPrice = true;
				this.initPriceTable();
			},
			// 合同价列表
			initPriceTable: function() {
				let _this = this;
				$(_this.$refs.price_list).bootstrapTable('destroy');
				$(_this.$refs.price_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getPriceList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "index",
						title: "序号",
						width: "10%",
						formatter: function(value, row, index) {
							return index + 1;
						}
					}, {
						field: "supplier_name",
						title: "供应商名称",
						width: "20%"
					}, {
						field: "shop_name",
						title: "门店名称",
						width: "15%"
					}, {
						field: "merchant_goods_name",
						title: "商品名称",
						width: "15%"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "15%"
					}, {
						field: "price",
						title: "合同价",
						width: "15%"
					}, {
						title: "操作",
						width: "20%",
						events: {
							'click .modify': function(e, value, row, index) {
								_this.modify_price = '2';
								$(_this.$refs.price_supplier).val(row.supplier_id).trigger('change');
								$(_this.$refs.price_supplier).prop('disabled', true);
								_this.price_goods_id = row.merchant_goods_id;
								_this.price_goods_name = row.merchant_goods_name;
								$(_this.$refs.price_goods_name).prop('disabled', true);
								_this.price_goods_unit = row.goods_unit_name
								_this.price_amount = row.price;
								_this.priceEdit('修改合同价', row.id);
							},
							'click .del': function(e, value, row) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delPrice(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue del">删除</span>'
						}
					}]
				});
			},
			getPriceList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.price_shop).val(),
							"supplier_id": $(_this.$refs.price_agent).val(),
							"merchant_goods_name": _this.price_name
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/getContractPriceList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			queryPrice: function() {
				if (this.getContractPriceByGoods) {
					this.list_page = 1
					this.getContractPriceGroupGoods(this.list_page)
				}else {
					this.initPriceTable();
				}
			},
			// 合同价导入
			priceXlsFun: function() {
				this.$refs.priceXlsFile.click();
			},
			// 导入
			uploadPriceXls: function(e) {
				let _this = this;

				let formData = new FormData();
				formData.append("contractPriceFile", $("#priceXlsFile")[0].files[0]);
				// 清除file
				let obj = document.getElementById('priceXlsFile');
				obj.value = '';

				$.ajax({
					type: "post",
					dataType: "json",
					processData: false,
					contentType: false,
					url: Vue.ctUrl + "Stock/importContractPrice",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: formData,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg('导入成功');
							$(_this.$refs.price_list).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							// layer.msg(data.response.error_msg);
							layer.open({
                                type: 1,
                                title: '导入失败，数据错误，请修正数据后重新导入！',
                                skin: 'import-err', // 加上边框
                                area: ['700px', ''],
                                content: data.response.error_msg
                            });
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 切换获取合同价方式
			changeGetMethod(getContractPriceByGoods) {
				this.getContractPriceByGoods = getContractPriceByGoods
				if (getContractPriceByGoods) {
					this.list_page = 1
					this.getContractPriceGroupGoods(this.list_page)
				}else {
					this.initPriceTable()
				}
			},

			// 按商品获取合同价
			getContractPriceGroupGoods(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('stock/getContractPriceGroupGoods', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.page_size,
                            "goods_name": _this.price_name,
                            "supplier_id": $(_this.$refs.price_agent).val(),
							"only_show_diff_price": _this.only_show_diff_price?'1':'-1',
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.count)
						}
						_this.list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "Stock/exportContractPrice"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.export_alert)
                }, function() {
                    _this.priceExport();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 点击导出
            priceExport: function() {
				let _this = this;
				let export_fields = JSON.stringify(_this.export_checkModel);
                window.location.href = Vue.ctUrl + "Stock/exportContractPrice?" +
                    "shop_id=" + $(_this.$refs.price_shop).val() +
                    "&supplier_id=" + $(_this.$refs.price_agent).val() +
                    "&merchant_goods_name=" + _this.price_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.export_type;
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 按商品导出
            byGoodExport: function() {
                window.location.href = Vue.ctUrl + "stock/exportContractPriceGroupGoods?" +
                    "supplier_id=" + $(this.$refs.price_agent).val() +
                    "&goods_name=" + this.price_name +
                    "&only_show_diff_price=" + (this.only_show_diff_price ? '1' : '-1')
                layer.msg("导出成功！")
            },
			syncCheckAll(val) {
				const _this = this;
				let ids = [];
				_this.shop_list.forEach(v => {
					ids.push(v.id);
				});
				_this.sync_shop_ids = val ? ids : [];
				_this.sync_sign = false;
			},
			syncShop(val) {
				let count = val.length;
				this.sync_check_all = count === this.shop_list.length;
				this.sync_sign = count > 0 && count < this.shop_list.length;
			},
			// 点击新增合同价
			addPrice: function() {
				this.modify_price = '1';
				$(this.$refs.price_supplier).val('').trigger('change');
				$(this.$refs.price_supplier).prop('disabled', false);
				this.price_goods_id = '';
				this.price_goods_name = '';
				$(this.$refs.price_goods_name).prop('disabled', false);
				this.price_goods_unit = ''
				this.price_amount = '';
				this.sync_sign = false;
				this.sync_check_all = false;
				this.sync_shop_ids = [];
				this.priceEdit('新增合同价', '');
			},
			// 新增、修改合同价
			priceEdit: function(name, id) {
				const _this = this;

				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: [name, true],
					area: ['660px', ''],
					content: $(_this.$refs.price_edit),
					offset: '100px'
				}, function() {
					if(_this.price_goods_id == '') {
						layer.msg('请选择商品');
						return false;
					} else if(_this.price_amount == '') {
						layer.msg('请输入合同价');
						return false;
					}
					if(_this.modify_price == '1') {
						Vue.axios.post('stock/checkShopsContractPrice', {
							"header": Vue.request_header,
							"request": {
								"version": Vue.version,
								"param": {
									"supplier_id": $(_this.$refs.price_supplier).val(),
									"merchant_goods_id": _this.price_goods_id,
									"shop_ids": _this.sync_shop_ids
								}
							},
							"comment": ""
						})
						.then(res => {
							if(res.data.response.result_code == "true") {
								if(res.data.response.result.legal) {
									_this.priceEditPost(id);
								} else {
									layer.confirm(res.data.response.result.msgs.join(), {
										btn: ['确定', '取消']
									}, function() {
										_this.priceEditPost(id);
									});
								}
							} else {
								Vue.timeoutfun(res.data.response.result_status, _this);
								layer.msg(res.data.response.error_msg);
							}
						})
						.catch(err => {
							layer.msg("出错啦");
						});
					} else {
						_this.priceEditPost(id);
					}
				});
			},
			priceEditPost(id) {
				const _this = this;
				let url = "stock/addContractPrice";
				let data = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"supplier_id": $(_this.$refs.price_supplier).val(),
							"merchant_goods_id": _this.price_goods_id,
							"price": _this.price_amount
						}
					},
					"comment": ""
				};
				if(_this.modify_price == '1') {
					data.request.param.shop_ids = _this.sync_shop_ids;
				} else if(_this.modify_price == '2') {
					data.request.param.id = id;
					url = "stock/updateContractPrice";
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.closeAll();
						$(_this.$refs.price_list).bootstrapTable('refresh');
						layer.msg(res.data.response.error_msg);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 删除合同价
			delPrice: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/delContractPrice",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg('删除成功');
							$(_this.$refs.price_list).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 返回列表
			backList: function() {
				this.showList = true;
				this.showPrice = false;
				// this.showGoods = false;
				$(this.$refs.price_shop).val('').trigger('change');
				$(this.$refs.price_agent).val('').trigger('change');
				this.price_name = '';
			},
			// 打开选择商品
			openPriceGoods: function() {
				let _this = this;
				_this.initGoodsTable();
				layer.open({
					type: 1,
					title: '选择商品',
					skin: 'layui-layer-rim', // 加上边框
					area: ['700px', ''], // 宽高
					content: $(_this.$refs.price_goods)
				});
			},
			// 商品类型
			getGoodsType: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [{ id: " ", text: "全部" }];
							$.each(data.response.result.data, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.goods_type).select2({
								data: arr,
								allowClear: true,
								width: '190px'
							});

							$(_this.$refs.sgoods_type).select2({
								data: arr,
								allowClear: true,
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 商品列表
			initGoodsTable: function() {
				let _this = this;
				$(_this.$refs.goods_list).bootstrapTable('destroy');
				$(_this.$refs.goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getGoodsList(params);
					},
					sidePagination: "server",
					columns: [{
						radio: true,
						title: '单选'
					}, {
						field: "shop_name",
						title: "门店名称"
					}, {
						field: "goods_type_name",
						title: "类型"
					}, {
						field: "goods_name",
						title: "名称"
					}, {
						field: "goods_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			getGoodsList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"goods_type": $.trim($(_this.$refs.goods_type).val()),
							"goods_name": _this.goods_name,
							"supplier_id": $(_this.$refs.price_supplier).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 关闭选择商品
			closeGoods: function() {
				layer.close(layer.index);
			},
			// 保存商品
			saveGoods: function() {
				let _this = this;
				$.map($(_this.$refs.goods_list).bootstrapTable('getSelections'), function(row) {
					_this.price_goods_id = row.id;
					_this.price_goods_name = row.goods_name;
					_this.price_goods_unit = row.goods_unit_name;
					layer.close(layer.index);
				});
			},
			// 查询商品
			queryGoods: function() {
				this.initGoodsTable();
			},

			// 点击“合同价批量删除”
			multiDelPrice() {
				const _this = this;
				_this.multi_pop_form.shop_id = $(_this.$refs.price_shop).val()
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['提示', true],
					area: ['550px', ''],
					content: $(_this.$refs.multi_del_pop),
					offset: '100px'
				}, function() {
					if(_this.multi_pop_form.supplier_id == '') {
						layer.msg('请选择供应商');
						return 
					}
					Vue.axios.post('stock/delContractPrice', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": '',
								"supplier_id": _this.multi_pop_form.supplier_id,
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.closeAll()
							layer.msg("删除成功！")
							_this.initPriceTable();
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
				});
			},

		}
	}
</script>

<style lang="less" scoped>
	.pull-right {
		button {
			margin: 0 0 0 30px;
		}
	}
	.set-export {
		padding: 0 20px 20px;
		h3 {
			font-size: 16px;
		}
		li {
			float: left;
			width: 20%;
		}
	}
	.supplier-list {
		.row-margin {
			button {
				margin: 0 30px 0 0;
			}
		}
		.supplier-tit-sel {
			width: 100px;
			padding: 0;
		}
		.supplier-con-val {
			padding-left: 0;
			margin-left: -1px;
		}
	}
	.supplier-price {
		.pull-right {
			button {
				margin: 0 0 0 30px;
			}
			>a {
				margin: 0 0 0 30px;
			}
			input {
				display: none;
			}
		}
		.el-checkbox {
			margin-top: 5px;
		}
		.by-good-table {
			.el-table__expanded-cell {
				padding: 0!important;
			}
			.gray-table {
				padding: 10px;
				background: #efefef;
				line-height: 24px;
				text-align: center;
				.table-header {
					font-weight: bold;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
				}
				.table-row {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
				}
				.name,
				.price {
					width: 30%;
				}
			}
		}
		
	}
	.add-supplier {
		width: 100%;
		height: 100%;
		display: none;
		padding: 30px 20px;
		font-size: 14px;
		>.row {
			margin-bottom: 10px;
		}
		.title {
			font-size: 14px;
			line-height: 48px;
			padding-right: 0;
		}
		.btns {
			margin-top: 50px;
			.col-md-4 {
				margin-left: 90px;
			}
		}
	}
	.price-goods {
		display: none;
		padding: 20px 30px 50px;
		.btns {
			width: 260px;
			margin: 10px auto 0;
			button {
				margin: 0 30px 0 0;
			}
		}
	}
	.price-sync {
		border-top: 1px dashed #CCC;
		h3 {
			font-size: 16px;
		}
	}
	.pb-edit-alert {
		max-height: 400px;
	}
	.multi-del-pop {
		.tip {
			text-align: center;
			color: red;
			margin: 0 0 20px 0;
		}
		.el-select {
			width: 320px;
		}
	}
</style>